import { render } from "./ShowMenomics.vue?vue&type=template&id=7ee55554"
import script from "./ShowMenomics.vue?vue&type=script&lang=js"
export * from "./ShowMenomics.vue?vue&type=script&lang=js"
script.render = render

export default script